export const colors = {
  white: 'white',
  red: 'red'
} as const
export type Colors = typeof colors[keyof typeof colors]
